import { render, staticRenderFns } from "./AdminLoginPage.vue?vue&type=template&id=a7824550&scoped=true"
import script from "./AdminLoginPage.vue?vue&type=script&lang=js"
export * from "./AdminLoginPage.vue?vue&type=script&lang=js"
import style0 from "./AdminLoginPage.vue?vue&type=style&index=0&id=a7824550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7824550",
  null
  
)

export default component.exports